"use strict";

module.exports = {
    isValidName : function (name) {
        if (!name) return false;

        var urlPattern = /(http|https):\/\//i;
        var specialCharPattern = /[{}\[\]^:<>|\\/~]/;
        var digitPattern = /\d/;
        var unicodeDigitPattern = /[\u4e00-\u9fff]+/;
        var blacklistPattern = /(WB|Ð´Ð°Ñ€Ð¸Ñ‚|Ð¿Ð¾Ð´Ð°Ñ€ÐºÐ)/i;

        // ——— new “gibberish” patterns ———
        var vowelPattern            = /[aeiouAEIOU]/g;
        var consonantClusterPattern = /[^aeiouAEIOU]{5,}/;
        var uppercasePattern = /[A-Z]/g;
        var uppercaseCount   = (name.match(uppercasePattern) || []).length;

        // 1) too many consonants side‑by‑side?
        if (consonantClusterPattern.test(name)) {
            return false;
        }

        // 2) no vowels at all (and more than 3 chars long)
        var vowels = name.match(vowelPattern) || [];
        if (name.length > 3 && vowels.length === 0) {
            return false;
        }

        // 3) too many uppercase letters (and more than 3 chars long)?
        if (name.length > 3 && uppercaseCount > 2) {
            return false;
        }
        // —————————————————————————— end gibberish checks ——————————————————————————

        return !(
            urlPattern.test(name) ||
            specialCharPattern.test(name) ||
            digitPattern.test(name) ||
            name.length > 40 ||
            name.length < 2 ||
            blacklistPattern.test(name) ||
            unicodeDigitPattern.test(name)
        );
    },
    isValidKatakanaName: function (katakanaName) {
        if (!katakanaName) return false;

        // Normalize to full-width (converts half-width Katakana → full-width)
        let name = katakanaName.normalize('NFKC').trim();

        // ——— Katakana validation pattern ———
        // Accepts only full-width Katakana characters (ァ–ヶ) and ー (long sound mark)
        // Adjust {2,30} for length limits
        let katakanaPattern = /^[ァ-ヶー]{2,30}$/u;

        // ——— Reject obvious invalid patterns ———
        let urlPattern = /(http|https):\/\//i;
        let specialCharPattern = /[{}\[\]^:<>|\\/~]/;
        let digitPattern = /\d/;
        let blacklistPattern = /(WB|Ð´Ð°Ñ|Ð¿Ð¾Ð´Ð)/i; // keep your blacklist, trimmed

        // ——— Validate ———
        if (
            !katakanaPattern.test(name) ||    // must be valid Katakana
            urlPattern.test(name) ||
            specialCharPattern.test(name) ||
            digitPattern.test(name) ||
            name.length > 30 ||
            name.length < 2 ||
            blacklistPattern.test(name)
        ) {
            return false;
        }

        return true;
    },
    isValidKanjiName: function (kanjiName) {
        if (!kanjiName) return false;

        // ——— Normalize input ———
        // Converts full-width/half-width variants to a consistent form
        let name = kanjiName.normalize('NFKC').trim();

        // ——— Kanji validation pattern ———
        // Includes:
        //  - CJK Unified Ideographs (4E00–9FFF)
        //  - Extension A (3400–4DBF)
        //  - Compatibility Ideographs (F900–FAFF)
        //  - Supplementary Ideographs (20000–2FA1F)
        // Adjust {2,30} for length limits
        let kanjiPattern = /^[\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF\u{20000}-\u{2FA1F}]{2,30}$/u;

        // ——— Reject obvious invalid patterns ———
        let urlPattern = /(http|https):\/\//i;
        let specialCharPattern = /[{}\[\]^:<>|\\/~]/;
        let digitPattern = /\d/;
        let blacklistPattern = /(WB|Ð´Ð°Ñ|Ð¿Ð¾Ð´Ð)/i;

        // ——— Validate ———
        if (
            !kanjiPattern.test(name) ||   // must contain only kanji
            urlPattern.test(name) ||
            specialCharPattern.test(name) ||
            digitPattern.test(name) ||
            name.length > 30 ||
            name.length < 2 ||
            blacklistPattern.test(name)
        ) {
            return false;
        }

        return true;
    }
} ;
